import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./MapCompare.module.scss";
import PathContext from "../../context/path";
import StateContext from "../../context/state";
import {
  gsap,
  Power0,
  Power2,
  MotionPathPlugin
} from 'gsap/all';
gsap.registerPlugin(Power0);
gsap.registerPlugin(Power2);
gsap.registerPlugin(MotionPathPlugin);
const MapCompare = () => {

  const path = useContext(PathContext);
  const state = useContext(StateContext);
  const { stage, updateTransition } = state;
  const [init, setInit] = useState(false);
  const [timeline, setTimeline] = useState(null);
  const [localStage, setLocalStage] = useState(0);
  const [transition, setTransition] = useState(false);
  const refWrap = useRef(null);
  const refOverlay = useRef(null);
  const refContainer = useRef(null);
  const refBody1 = useRef(null);
  const refBg = useRef(null);
  const refBgOverlay = useRef(null);
  const refGradient = useRef(null);
  const refAirplane = useRef(null);
  const refTrain = useRef(null);
  const refShip = useRef(null);
  const refStat1 = useRef(null);
  const refStat2 = useRef(null);
  const refStat3 = useRef(null);
  const refStat4 = useRef(null);
  const refStat5 = useRef(null);
  const refStat6 = useRef(null);
  const refStat7 = useRef(null);
  const refStat8 = useRef(null);
  const refStat9 = useRef(null);
  const refStats = useRef(null);

  useEffect(() => {
    const tl = gsap.timeline({ paused: true });
    const wrap = refWrap.current;
    const body1 = refBody1.current;
    const overlay = refOverlay.current;
    const container = refContainer.current;
    const bgOverlay = refBgOverlay.current;
    const gradient = refGradient.current;
    const airplane = refAirplane.current;
    const train = refTrain.current;
    const ship = refShip.current;
    const stats = refStats.current;
    const stat1 = refStat1.current;
    const stat2 = refStat2.current;
    const stat3 = refStat3.current;
    const stat4 = refStat4.current;
    const stat5 = refStat5.current;
    const stat6 = refStat6.current;
    const stat7 = refStat7.current;
    const stat8 = refStat8.current;
    const stat9 = refStat9.current;
    const statLength = stat1.getTotalLength();
    tl
      .to(wrap, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 1 })
      .to(overlay, { duration: 0.1, ease: 'power2.inOut', scale: 0, autoAlpha: 1 }, '-=0.1')
      .to(container, { duration: 0.1, ease: 'power2.inOut', scale: 1, x: '-50%', y: '-50%' }, '-=0.1')
      .to(bgOverlay, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(gradient, { duration: 0.1, autoAlpha: 1 }, '-=0.1')
      .to(stats, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(body1, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 1 }, '-=0.1')
      .to(airplane, { duration: 0.1, ease: 'none', y: '0', x: '0vw' }, '-=0.1')
      .to(train, { duration: 0.1, ease: 'none', y: '0%', x: '0vw' }, '-=0.1')
      .to(ship, { duration: 0.1, ease: 'none', y: '0%', x: '0vw' }, '-=0.1')
      .to(stat1, { duration: 0.1, visibility: 'hidden', strokeDasharray: statLength, strokeDashoffset: statLength }, '-=0.1')
      .to(stat2, { duration: 0.1, visibility: 'hidden', strokeDasharray: statLength, strokeDashoffset: statLength }, '-=0.1')
      .to(stat3, { duration: 0.1, visibility: 'hidden', strokeDasharray: statLength, strokeDashoffset: statLength }, '-=0.1')
      .to(stat4, { duration: 0.1, visibility: 'hidden', strokeDasharray: statLength, strokeDashoffset: statLength }, '-=0.1')
      .to(stat5, { duration: 0.1, visibility: 'hidden', strokeDasharray: statLength, strokeDashoffset: statLength }, '-=0.1')
      .to(stat6, { duration: 0.1, visibility: 'hidden', strokeDasharray: statLength, strokeDashoffset: statLength }, '-=0.1')
      .to(stat7, { duration: 0.1, visibility: 'hidden', strokeDasharray: statLength, strokeDashoffset: statLength }, '-=0.1')
      .to(stat8, { duration: 0.1, visibility: 'hidden', strokeDasharray: statLength, strokeDashoffset: statLength }, '-=0.1')
      .to(stat9, { duration: 0.1, visibility: 'hidden', strokeDasharray: statLength, strokeDashoffset: statLength }, '-=0.1')
      .add('stage-0')
      .to(gradient, { duration: 0.5, autoAlpha: 0 })
      .to(stats, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(airplane, { duration: 5, ease: 'none', x: '70.6vw' }, '-=0.5')
      .to(train, { duration: 5, ease: 'none', x: '42vw' }, '-=5')
      .to(ship, { duration: 5, ease: 'none', x: '26vw' }, '-=5')
      .to(stat1, { duration: 5, visibility: 'visible', strokeDashoffset: statLength - (statLength * 0.8) }, '-=5')
      .to(stat2, { duration: 5, visibility: 'visible', strokeDashoffset: statLength - (statLength * 0.8) }, '-=5')
      .to(stat3, { duration: 5, visibility: 'visible', strokeDashoffset: statLength - (statLength * 0.33) }, '-=5')
      .to(stat4, { duration: 5, visibility: 'visible', strokeDashoffset: statLength - (statLength * 0.05 * 0.66) }, '-=5')
      .to(stat5, { duration: 5, visibility: 'visible', strokeDashoffset: statLength - (statLength * 0.4 * 0.66) }, '-=5')
      .to(stat6, { duration: 5, visibility: 'visible', strokeDashoffset: statLength - (statLength * 0.55 * 0.66) }, '-=5')
      .to(stat7, { duration: 5, visibility: 'visible', strokeDashoffset: statLength - (statLength * 0.17 * 0.5) }, '-=5')
      .to(stat8, { duration: 5, visibility: 'visible', strokeDashoffset: statLength - (statLength * 0.17 * 0.5) }, '-=5')
      .to(stat9, { duration: 5, visibility: 'visible', strokeDashoffset: statLength - (statLength * 0.85 * 0.5) }, '-=5')
      .add('stage-1')
      .to(train, { duration: 2, ease: 'none', x: '70vw' })
      .to(airplane, { duration: 2, ease: 'none', x: '120vw' }, '-=2')
      .to(ship, { duration: 2, ease: 'none', x: '41vw' }, '-=2')
      .to(stat4, { duration: 2, visibility: 'visible', strokeDashoffset: statLength - (statLength * 0.05) }, '-=2')
      .to(stat5, { duration: 2, visibility: 'visible', strokeDashoffset: statLength - (statLength * 0.4) }, '-=2')
      .to(stat6, { duration: 2, visibility: 'visible', strokeDashoffset: statLength - (statLength * 0.55) }, '-=2')
      .to(stat7, { duration: 2, visibility: 'visible', strokeDashoffset: statLength - (statLength * 0.17 * 0.75) }, '-=2')
      .to(stat8, { duration: 2, visibility: 'visible', strokeDashoffset: statLength - (statLength * 0.17 * 0.75) }, '-=2')
      .to(stat9, { duration: 2, visibility: 'visible', strokeDashoffset: statLength - (statLength * 0.85 * 0.75) }, '-=2')
      .add('stage-2')
      .to(ship, { duration: 2, ease: 'none', x: '70vw' })
      .to(train, { duration: 2, ease: 'none', x: '140vw' }, '-=2')
      .to(stat7, { duration: 2, visibility: 'visible', strokeDashoffset: statLength - (statLength * 0.17) }, '-=2')
      .to(stat8, { duration: 2, visibility: 'visible', strokeDashoffset: statLength - (statLength * 0.17) }, '-=2')
      .to(stat9, { duration: 2, visibility: 'visible', strokeDashoffset: statLength - (statLength * 0.85) }, '-=2')
      .add('stage-3')
      .to(overlay, { duration: 1, ease: 'power2.inOut', scale: 1 })
      .to(container, { duration: 1, ease: 'power2.inOut', scale: 1.5 }, '-=1')
      .add('stage-4')
      .add('stage-5')
      .add('stage-6')
      .add('stage-7')
      ;
    setTimeline(tl);
  }, []);

  useEffect(() => {
    if (!init) {
      if (timeline !== null) {
        setInit(true);
        timeline.seek(`stage-${stage}`);
        setLocalStage(stage);
      }
    }
  }, [init, stage, timeline]);
  useEffect(() => {
    let diff = Math.abs(localStage - stage);
    if (timeline !== null) {
      if (diff !== 0 && !transition) {
        setTransition(true);
        updateTransition(true);
        if (diff > 1) {
          refWrap.current.classList.add(styles.hide);
          setTimeout(() => {
            timeline.seek(`stage-${stage}`);
            refWrap.current.classList.remove(styles.hide);
            setTransition(false);
            setTimeout(() => {
              updateTransition(false);
            }, 800);
          }, 300);
        } else {
          let minimalDelay = false;
          let minimalDelayTimer = setTimeout(() => {
            minimalDelay = true;
          }, 800);
          timeline.tweenTo(`stage-${stage}`, {
            onComplete: function () {
              setTransition(false);
              clearTimeout(minimalDelayTimer);
              if (minimalDelay) {
                updateTransition(false);
              } else {
                setTimeout(() => {
                  updateTransition(false);
                }, 500);
              }
            }
          });
        }
        setLocalStage(stage);
      }
    }
  }, [localStage, stage, timeline, transition, updateTransition]);

  return (
    <>
      <div className={styles.wrap} ref={refWrap}>
        <div className={styles.overlay} ref={refOverlay}></div>
        <div className={styles.container} ref={refContainer}>
          <div className={styles.body} ref={refBody1}>
            <div className={styles.stats} ref={refStats}>
              <div className={styles.stats__group}>
                <div className={styles.stat}>
                  <svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="39" cy="39" r="36" stroke="#EEEEEE" strokeWidth="6" />
                    <circle cx="39" cy="39" r="36" stroke="#67D672" strokeWidth="6" ref={refStat1} />
                  </svg>
                  <span>CO<sup>2</sup></span>
                </div>
                <div className={styles.stat}>
                  <svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="39" cy="39" r="36" stroke="#EEEEEE" strokeWidth="6" />
                    <circle cx="39" cy="39" r="36" stroke="#67D672" strokeWidth="6" ref={refStat2} />
                  </svg>
                  <span>₽</span>
                </div>
                <div className={styles.stat}>
                  <svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="39" cy="39" r="36" stroke="#EEEEEE" strokeWidth="6" />
                    <circle cx="39" cy="39" r="36" stroke="#67D672" strokeWidth="6" ref={refStat3} />
                  </svg>
                  <img src={`${path}/img/icon-stat.svg`} alt="" />
                </div>
              </div>
              <div className={styles.stats__group}>
                <div className={styles.stat}>
                  <svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="39" cy="39" r="36" stroke="#EEEEEE" strokeWidth="6" />
                    <circle cx="39" cy="39" r="36" stroke="#67D672" strokeWidth="6" ref={refStat4} />
                  </svg>
                  <span>CO<sup>2</sup></span>
                </div>
                <div className={styles.stat}>
                  <svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="39" cy="39" r="36" stroke="#EEEEEE" strokeWidth="6" />
                    <circle cx="39" cy="39" r="36" stroke="#67D672" strokeWidth="6" ref={refStat5} />
                  </svg>
                  <span>₽</span>
                </div>
                <div className={styles.stat}>
                  <svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="39" cy="39" r="36" stroke="#EEEEEE" strokeWidth="6" />
                    <circle cx="39" cy="39" r="36" stroke="#67D672" strokeWidth="6" ref={refStat6} />
                  </svg>
                  <img src={`${path}/img/icon-stat.svg`} alt="" />
                </div>
              </div>
              <div className={styles.stats__group}>
                <div className={styles.stat}>
                  <svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="39" cy="39" r="36" stroke="#EEEEEE" strokeWidth="6" />
                    <circle cx="39" cy="39" r="36" stroke="#67D672" strokeWidth="6" ref={refStat7} />
                  </svg>
                  <span>CO<sup>2</sup></span>
                </div>
                <div className={styles.stat}>
                  <svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="39" cy="39" r="36" stroke="#EEEEEE" strokeWidth="6" />
                    <circle cx="39" cy="39" r="36" stroke="#67D672" strokeWidth="6" ref={refStat8} />
                  </svg>
                  <span>₽</span>
                </div>
                <div className={styles.stat}>
                  <svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="39" cy="39" r="36" stroke="#EEEEEE" strokeWidth="6" />
                    <circle cx="39" cy="39" r="36" stroke="#67D672" strokeWidth="6" ref={refStat9} />
                  </svg>
                  <img src={`${path}/img/icon-stat.svg`} alt="" />
                </div>
              </div>
            </div>

            <div className={styles.vehicles}>
              <div className={styles.airplane} ref={refAirplane}>
                <img src={`${path}/img/airplane-compare.svg`} alt="" />
              </div>
              <div className={styles.train} ref={refTrain}>
                <img src={`${path}/img/train-compare.svg`} alt="" />
              </div>
              <div className={styles.ship} ref={refShip}>
                <img src={`${path}/img/ship-compare.svg`} alt="" />
              </div>
            </div>
            <div className={styles.clouds}>
              <div className={styles.cloud}>

                <img src={`${path}/img/clouds-compare.svg`} alt="" />
              </div>
              <div className={styles.cloud}>

                <img src={`${path}/img/clouds-compare.svg`} alt="" />
              </div>
            </div>
            <div className={styles.gradient} ref={refGradient}></div>
            <div className={styles.bg} ref={refBg}>
              <div className={styles.bg__overlay} ref={refBgOverlay}></div>
              <div className={styles.grounds}>
                <div className={styles.ground}>
                  <img src={`${path}/img/map-compare.webp`} alt="" />
                </div>
                <div className={styles.ground}>
                  <img src={`${path}/img/map-compare.webp`} alt="" />
                </div>
                <div className={styles.ground}>
                  <img src={`${path}/img/map-compare.webp`} alt="" />
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

}

export default MapCompare;
